import { FC } from 'react'
import { ApolloProvider } from '@apollo/client'
import {
  CssResetComponent,
  customEvent,
  FinanceWidgetEvents,
  JsonnetConfigProvider,
  MinimalLoader,
  ParallelContextualizedInitializer,
  useWidgetContext,
  TranslationsProvider,
} from '@dxp-module/common'
import useApolloClient from './common/hooks/useApolloClient'
import FinanceCalculatorWidgetContent from './FinanceCalculatorWidgetContent'
import CashContextProvider from './common/providers/CashContext.provider'

const FinanceCalculatorWidget: FC = () => {
  const { client } = useApolloClient()
  const { eventContainer } = useWidgetContext()
  eventContainer.emit(FinanceWidgetEvents.INITIALIZED)
  customEvent.emit(FinanceWidgetEvents.FC_ACTIVE, true)

  return (
    <CssResetComponent>
      <ApolloProvider client={client}>
        <ParallelContextualizedInitializer
          initializers={[JsonnetConfigProvider, TranslationsProvider]}
          loader={<MinimalLoader />}
        >
          <CashContextProvider>
            <FinanceCalculatorWidgetContent />
          </CashContextProvider>
        </ParallelContextualizedInitializer>
      </ApolloProvider>
    </CssResetComponent>
  )
}

export default FinanceCalculatorWidget
